import { FC } from 'react';

import { styled } from '@mui/material/styles';

const PRIVACY_HTML_URL = 'https://storage.googleapis.com/expain_documents/Privacy%20Policy.html';

const Privacy: FC = () => <StyledIframe src={PRIVACY_HTML_URL} title="Privacy Policy" />;

const StyledIframe = styled('iframe')`
  width: 100%;
  height: 100%;
  border: none;
`;

export default Privacy;
